export default "__VITE_ASSET__c6VAP1y9__"